import React from 'react';
import { Config } from '@leverege/plugin';
import { LinkAction } from '@leverege/molten/routes';
import { ItemDelegate } from '@leverege/molten/imagine';
import AlertScreen from './views/AlertScreen';
function processRelationship(molten, relationship, options) {
  const {
    blueprint,
    path,
    objectType,
    attribute
  } = relationship;
  const urlPath = attribute?.isOneToOne() ? `${relationship.urlPath}/info` : `${relationship.urlPath}/:${blueprint.type}Id/locationAlerts`;
  if (blueprint.type === 'location') {
    molten.addPlugin('Action', LinkAction.create({
      id: `recovr.link.${path}.LocationAlerts`,
      layout: {
        sort: 'b.4'
      },
      matches: {
        use: 'navBar',
        objectType,
        path
      },
      handles: () => true,
      name: 'Alert Rules',
      path: urlPath,
      icon: Config.get('AlertRules', 'navIcon', 'https://recovr-ui-assets.storage.googleapis.com/icon-alert-rules.png')
    }));
    molten.addPlugin('Route', {
      id: `recovr.${path}.LocationAlertScreen`,
      matches: {
        objectType,
        path
      },
      exact: true,
      path: urlPath,
      render: ({
        match,
        ...rest
      }) => {
        const resourceId = attribute?.isOneToOne() ? attribute.path : match.params[`${blueprint.type}Id`];
        const iRel = relationship.createItem(match, resourceId);
        const props = {
          match,
          ...rest,
          relationship: iRel,
          resourceId,
          objectType: attribute?.blueprint.type || blueprint.type,
          actions: new ItemDelegate({
            match,
            relationship: iRel,
            id: resourceId
          }) // TODO ITEM ACTIONS
        };
        return /*#__PURE__*/React.createElement(AlertScreen, props);
      }
    });
  }
}
export default {
  id: 'recovr.AlertsRouteCreator',
  type: 'recovr.AlertsRouteCreator',
  processRelationship
};